import React from 'react'
import {ShapeSlider} from "./DrawingShape.css";
import {Delete} from "@mui/icons-material";
import {IconButton} from "@mui/material";

const DrawingShape = ({
                          // Blurring vs. highlighting
                          mode,

                          // Orientation for the drawing area
                          canvasTop,
                          canvasLeft,
                          canvasHeight,
                          canvasWidth,

                          // Initial shape values
                          shapeLeft,
                          shapeTop,
                          shapeWidth,
                          shapeHeight,

                          // Toggles for showing / hiding certain elements (i.e. sliders and toolbar)
                          drawingMode,
                          previewMode,

                          // Fires after each change
                          shapeUpdated,

                          // Callback if shape deletion is triggered
                          shapeDeleted
                      }) => {

    const getShapeStyle = () => {

        let shapeStyle

        if (mode === "blur") {
            if (drawingMode) {
                shapeStyle = {
                    backgroundImage: "linear-gradient(white, black)",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: "30px",
                    border: "3px solid black",
                    opacity: 0.5
                }
            } else {
                shapeStyle = {
                    backgroundImage: "linear-gradient(white, black)",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: "30px"
                }
            }
        }

        if (mode === "highlight") {
            shapeStyle = {
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                borderRadius: "50%",
                border: "3px solid yellow"
            }
        }

        return {
            position: "absolute",
            left: canvasLeft + (shapeLeft / 100 * canvasWidth),
            width: (shapeWidth / 100 * canvasWidth),
            top: canvasTop + (shapeTop / 100 * canvasHeight),
            height: (shapeHeight / 100 * canvasHeight),
            ...shapeStyle
        }
    }

    return (
        <div>
            {/* Height and top position slider */}

            {drawingMode && <div style={{
                position: "absolute",
                left: 5 + canvasLeft + (shapeLeft / 100 * canvasWidth) + (shapeWidth / 100 * canvasWidth),
                top: canvasTop,
                height: canvasHeight,
                zIndex: 1000
            }}>
                <ShapeSlider min={0} max={canvasHeight} orientation={"vertical"}
                                     value={[canvasHeight - shapeTop / 100 * canvasHeight, canvasHeight - (shapeTop + shapeHeight) / 100 * canvasHeight]} // Set absolute values
                                     onChange={(event, data) => {
                                         /*
                                         The additional "canvasHeight" needs to be included, because we need to "invert" the scale.
                                         As the rotation is exactly the other way around...
                                          */

                                         // top, left, width, height (set relative values)
                                         shapeUpdated(
                                             100 / canvasHeight * (canvasHeight - data[1]),
                                             shapeLeft,
                                             shapeWidth,
                                             100 / canvasHeight * (data[1] - data[0]))
                                     }}/>
            </div>}

            {/* Width and left position slider */}
            {drawingMode && <div style={{
                position: "absolute",
                left: canvasLeft,
                width: canvasWidth,
                top: 5 + canvasTop + (shapeTop / 100 * canvasHeight) + (shapeHeight / 100 * canvasHeight),
                zIndex: 1000
            }}>
                <ShapeSlider min={0} max={canvasWidth}
                                       value={[shapeLeft / 100 * canvasWidth, (shapeLeft + shapeWidth) / 100 * canvasWidth]} // Set absolute values
                                       onChange={(event, data) => {

                                           // top, left, width, height (set relative values)
                                           shapeUpdated(
                                               shapeTop,
                                               100 / canvasWidth * data[0],
                                               100 / canvasWidth * (data[1] - data[0]),
                                               shapeHeight)
                                       }}/>
            </div>}

            {/* Shape deletion action */}
            {drawingMode && <div style={{
                position: "absolute",
                left: canvasLeft + (shapeLeft / 100 * canvasWidth) + (shapeWidth / 100 * canvasWidth) / 2 - 25,
                top: canvasTop + (shapeTop / 100 * canvasHeight) + (shapeHeight / 100 * canvasHeight) / 2 - 25,
                zIndex: 1000
            }}>

                <IconButton
                    onClick={() => {
                        shapeDeleted()
                    }
                    }
                    style={{color: "white"}}
                    size="large">
                    <Delete/>
                </IconButton>

            </div>}

            {/* Rendering of the actual shape: container which defines the area (FF does not support the backdropFilter unfortunately) */}
            {(drawingMode || previewMode) &&
            <div style={getShapeStyle()}/>}
        </div>
    );
}

export default DrawingShape
